import { ICalendarFilter } from "../../calendar";
import { IItem } from "../../../shared/model/types";
import { ITrialLesson } from "../model/types";

export const getTrialSelectedIdItems = (selectedId: string): string[] => {
    return selectedId ? [selectedId] : []
}

export const getTrialCalendarFilter = (tgAccountId: string, tagId: string): ICalendarFilter => ({
    tgAccountIds: tgAccountId ? [tgAccountId] : [],
    userIds: [],
    studentIds: [],
    tagIds: tagId ? [tagId] : [],
    includeCancelled: true,
    includeRescheduled: true,
})

export const getTrialOptionItems = <TItem extends {id: string}>(
    items: TItem[],
    getName: (item: TItem) => string,
): IItem<string>[] => {
    return items.map(item => ({
        id: item.id,
        name: getName(item),
    }))
}

export const getTrialRequestErrorMessage = (error: unknown, fallback: string): string => {
    if(!(error instanceof Error)) return fallback

    try{
        const data = JSON.parse(error.message) as {message?: string}
        return data.message || fallback
    }
    catch{
        return error.message || fallback
    }
}

export const getTrialLessonTagName = (trialLesson: ITrialLesson): string => {
    if(typeof trialLesson.tag === 'string'){
        return trialLesson.tag || 'Без тега'
    }

    const staffTagName = trialLesson.staffTag?.name?.trim()
    if(staffTagName){
        return staffTagName
    }

    const tagName = trialLesson.tag?.name?.trim()
    if(tagName){
        return tagName
    }

    const tagId = trialLesson.staffTag?.id || trialLesson.tag?.id
    if(tagId){
        return `Тег #${tagId}`
    }

    return 'Без тега'
}
